<div class="ayuda mt-5 pt-5 pb-5">

  <div class="titulo">
    <app-titulo-descripcion titulo={{titulo}} descripcion={{descripcion}}></app-titulo-descripcion>
  </div>

  <!-- <div class="tu-ayuda m-auto pt-5">
    <h2 class="subtitulo-a text-center mb-3">
      <i class="fas fa-handshake icono mr-2"></i>
      <strong class="text-dark">{{subtituloA}} </strong>
    </h2>

    <img class="imagen m-auto pb-3" src="../../../assets/img/foto-donar-4.jpg" alt="">

    <p class="text-justify texto" [ngClass]="{'mt3': i == 0}" *ngFor="let textos of textosAyuda; let i=index">
      {{textos.texto}}
    </p>

  </div> -->

  <div class="donaciones m-auto pt-5">
    <h2 class="subtitulo-b text-center mb-3">
      <i class="fas fa-heart icono mr-2"></i>
      <strong class="text-dark">{{subtituloB}} </strong>
    </h2>
    <div class="donacion text-center" *ngFor="let datos of datosAyuda; let i=index">
      <app-carta-img-arrb imagen={{datos.imagen}}>
      </app-carta-img-arrb>
      <button *ngIf="i == 0" class="btn btn-primary" (click)="abrirModal(plantilla1)">TRANSFERENCIA</button>
      <button *ngIf="i == 1" class="btn btn-primary" (click)="enlace()">TARJETA DE CREDITO/DEBITO</button>
      <button *ngIf="i == 2" class="btn btn-primary" (click)="abrirModal(plantilla2)">MATERIALES</button>
    </div>
  </div>
</div>

<ng-template #plantilla1>
  <div class="modal-header bg-primary">
    <h4 class="modal-title pull-left text-secondary"><b>DATOS BANCARIOS</b></h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="referModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center bg-secondary">
    BANCO CIUDAD <br>
    CBU: 0290018600000000381996 <br>
    Cta Cte: Asoc. Jesús Amigo. <br>
    CUIT: 30-67824230-2 <br>
    <button type="button" class="btn btn-secondary btn-lg mr-3 mt-3" (click)="referModal.hide()">Cerrar</button>
  </div>
</ng-template>

<ng-template #plantilla2>
  <div class="modal-header bg-primary">
    <h4 class="modal-title pull-left text-secondary"><b>ATENCIÓN AL PUBLICO</b></h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="referModal.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body text-center bg-secondary">
    Puedes traer tus donaciones materiales a: <br>
    Pasaje La Facultad 1628 - CABA <br>
    Parque Avellaneda <br>
    De L a V de 10:00 a 18:00 hrs <br>
    <button type="button" class="btn btn-secondary btn-lg mr-3 mt-3" (click)="referModal.hide()">Cerrar</button>
  </div>
</ng-template>
